import TreeViewPlayground from '../dev-playground/TreeViewPlayground.vue';

export default
[
    {
        path: '/dev/playground/tree-view',
        name: 'dev-playground-tree-view',
        component: TreeViewPlayground,
    },
];
